module.exports = __webpack_public_path__ + "img/export-mobile.0ff18743.svg";